;(function () {
  'use strict'

  angular
    .module('contrast.licenses-activity-series')
    .directive('csLicensesActivitySeries', csLicensesActivitySeries)

  function csLicensesActivitySeries(
    $window,
    chartLicensesActivityBuilderService,
    chartProtectUsageBuilderService,
    Highcharts,
    HIGHCHARTS_COLORS,
    CHART_ID,
    CHART_EVENTS
  ) {
    'ngInject'

    var parentChart

    var rendering = false
    var currentChart
    var uniqueId = 1

    return {
      restrict: 'E',
      scope: {
        licensesActivityConfig: '=',
        protectUsageConfig: '=',
        fillHeight: '=',
        minWidth: '='
      },
      link: link
    }

    function link($scope, element) {
      var id = CHART_ID.LICENSES_ACTIVITY_CHART + '-' + uniqueId++,
        parent = element.parent()

      element.attr('id', id)

      var height = _calculateHeight($scope.fillHeight, parent, element)
      // apply a set of options to all charts on the same page
      _applyGlobalHighchartsOptions(height)

      element.css('height', height + 'px')

      currentChart = CHART_ID.LICENSES_ACTIVITY_CHART // set Licenses Activity chart as starting point

      $scope.$watch(
        function () {
          return $scope.licensesActivityConfig
            ? $scope.licensesActivityConfig.data
            : $scope.$parent.licensesActivityConfig.data
        },
        function (newValue) {
          if (newValue) {
            renderChart(element[0], parent.width(), true)
          }
        }
      )

      $scope.$watch(
        function () {
          return $scope.protectUsageConfig
            ? $scope.protectUsageConfig.data
            : $scope.$parent.protectUsageConfig.data
        },
        function (newValue) {
          if (newValue) {
            renderChart(element[0], parent.width(), true)
          }
        }
      )

      $scope.$watch(
        function () {
          return parent.width() + element.width()
        },
        function (newValue, oldValue) {
          if (
            newValue &&
            newValue !== oldValue &&
            angular.isDefined(parentChart)
          ) {
            var width =
              parent.width() > $scope.minWidth
                ? parent.width()
                : $scope.minWidth
            renderChart(element[0], width, false)
          }
        }
      )

      function renderChart(renderTo, width, force) {
        switch (currentChart) {
          case CHART_ID.PROTECT_AGENT_USAGE_CHART:
            _renderProtectUsageChart(
              $scope,
              renderTo,
              force,
              width,
              $scope.protectUsageConfig,
              false
            )
            break
          case CHART_ID.PROTECT_USAGE_HOURS_CHART:
            _renderProtectUsageChart(
              $scope,
              renderTo,
              force,
              width,
              $scope.protectUsageConfig,
              true
            )
            break
          case CHART_ID.LICENSES_ACTIVITY_CHART:
          default:
            _renderLicensesActivityChart(
              $scope,
              renderTo,
              force,
              width,
              $scope.licensesActivityConfig
            )
        }
      }

      function _renderLicensesActivityChart(
        scope,
        renderTo,
        force,
        width,
        config
      ) {
        if (config && config.data && (!rendering || force)) {
          if (config.data.rawData && config.data.rawData.length > 0) {
            element.removeClass('hidden-mode')
            rendering = true
            chartLicensesActivityBuilderService
              .buildLicensesActivityChart(
                scope,
                renderTo,
                parentChart,
                width,
                config
              )
              .then(function (response) {
                parentChart = response
                rendering = false
              })
          } else {
            element.addClass('hidden-mode')
          }
        }
      }

      function _renderProtectUsageChart(
        scope,
        renderTo,
        force,
        width,
        config,
        isUsageHour
      ) {
        if (config && config.data && (!rendering || force)) {
          if (config.data.rawData && config.data.rawData.length > 0) {
            element.removeClass('hidden-mode')
            rendering = true
            chartProtectUsageBuilderService
              .buildProtectUsageChart(
                scope,
                renderTo,
                parentChart,
                width,
                config,
                isUsageHour
              )
              .then(function (response) {
                parentChart = response
                rendering = false
              })
          } else {
            element.addClass('hidden-mode')
          }
        }
      }

      function _loadProtectUsageChart(chartId, isDataRequest, element, width) {
        currentChart = chartId
        renderChart(element, width, true)
        $scope.$emit(CHART_EVENTS.LOAD_PROTECT_USAGE, {
          chartId: currentChart,
          retrieveData: isDataRequest
        })
        $scope.$apply()
      }

      function onResize() {
        $scope.$digest()
      }

      angular.element($window).on('resize', onResize)

      function onDestroy() {
        angular.element($window).off('resize', onResize)
      }

      $scope.$on('$destroy', onDestroy)

      $scope.$on(
        CHART_EVENTS.DRILLDOWN_LICENSE_ACTIVITY_TO_AGENT_USAGE,
        function (event, data) {
          element.addClass('hidden-mode')

          currentChart = CHART_ID.PROTECT_AGENT_USAGE_CHART
          $scope.$emit(CHART_EVENTS.LOAD_PROTECT_USAGE, {
            totalProtectLicenses: data.totalProtectLicenses,
            chartId: CHART_ID.PROTECT_AGENT_USAGE_CHART,
            retrieveData: true
          })
        }
      )

      $scope.$on(
        CHART_EVENTS.DRILLDOWN_AGENT_USAGE_TO_USAGE_HOURS,
        function () {
          _loadProtectUsageChart(
            CHART_ID.PROTECT_USAGE_HOURS_CHART,
            false,
            element[0],
            element.parent().width()
          )
        }
      )

      $scope.$on(
        CHART_EVENTS.DRILLDOWN_USAGE_HOURS_TO_AGENT_USAGE,
        function () {
          _loadProtectUsageChart(
            CHART_ID.PROTECT_AGENT_USAGE_CHART,
            false,
            element[0],
            element.parent().width()
          )
        }
      )

      $scope.$on(CHART_EVENTS.RENDER_LICENSES_ACTIVITY, function () {
        currentChart = CHART_ID.LICENSES_ACTIVITY_CHART
        renderChart(element[0], element.parent().width(), true)
      })
    }

    function _applyGlobalHighchartsOptions(height) {
      //Remove hyperlink from tick labels
      Highcharts.Tick.prototype.drillable = function () {}

      Highcharts.setOptions({
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        title: {
          text: null
        },
        chart: {
          backgroundColor: null,
          height: height,
          marginRight: 30,
          marginLeft: 30,
          marginTop: 20
        },
        loading: {
          labelStyle: {
            color: HIGHCHARTS_COLORS.TRANSPARENT
          },
          style: {
            backgroundColor: HIGHCHARTS_COLORS.TRANSPARENT
          }
        },
        plotOptions: {
          area: {
            lineWidth: 1,
            states: {
              hover: {
                lineWidth: 2,
                halo: {
                  size: 0
                }
              }
            }
          }
        },
        xAxis: {
          lineColor: HIGHCHARTS_COLORS.TRANSPARENT,
          lineWidth: 0,
          tickLength: 0,
          type: 'datetime'
        },
        yAxis: {
          gridLineColor: HIGHCHARTS_COLORS.TRANSPARENT,
          minPadding: 0,
          maxPadding: 0,
          labels: {
            enabled: false
          },
          title: {
            text: null
          }
        }
      })
    }

    function _calculateHeight(fillHeight, parent, element) {
      var height = 200
      if (fillHeight) {
        var parentHeight = parent.height(),
          siblingHeight = 0

        parent.children().each(function (index, ele) {
          if (ele.id !== element[0].id) {
            siblingHeight += angular.element(ele).height()
          }
        })

        if (siblingHeight > 0) {
          height = parentHeight - siblingHeight
        }

        height = height <= 10 ? parentHeight : height

        if (angular.isNumber(fillHeight)) {
          height = Math.max(height, fillHeight)
        }
      }

      return height
    }
  }
})()
